import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { selectQuestionsAndOptions, addBookedPatient, addQuestionnaire, delBookedPatientAndQuestionnaire, getExcludeQuestions as _getExcludeQuestions, getQuestionnaireTypeID as _getQuestionnaireTypeID } from '@/api/module/index';
import { getOrderCount, addOrder, getSetBookedTime as _getSetBookedTime } from '@/api/module/user';
import { Dialog, Toast } from 'vant';
import { getNextMonth, getNow, formatDate } from '@/assets/utils/dateUtil';
import { GetAge } from '@/assets/utils/utils';
import { decrypt, encrypt } from "@/assets/utils/cryptoUtil";
export default {
  name: "index",
  data: function data() {
    return {
      radio: '0',
      list: [],
      result: [],
      questionList: [],
      //所有问卷问题
      currentQuestion: {},
      //当前问题
      currentIndex: undefined,
      //当前是第几个
      currentPersent: '0%',
      //当前进度
      currentProgress: '0',
      prevText: '返回首页',
      nextText: '下一题',
      allAnswer: new Map(),
      //当前选择的题目答案
      show: false,
      //显示套餐组合
      showPackage: false,
      //显示套餐组合
      showDate: false,
      //显示日历控件
      date: '',
      minDate: new Date(),
      maxDate: new Date(),
      checkDate: undefined,
      //预约体检时间
      orderCount: [],
      //预约排班
      orderArr: new Array(),
      showSuccess: false,
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      user: {},
      //登录用户信息
      basePackage: [],
      //基础体检套餐
      vipPackage: [],
      //尊享VIP套餐
      deepPackage: [],
      //深度体检套餐
      currentName: '',
      currentPackage: [],
      bookedNo: '',
      fadeEnter: 'fade-enter',
      fadeLeaveActive: 'fade-leave-active'
    };
  },
  created: function created() {
    this.getQuestionnaireTypeID();
    this.getList();
    this.getCount();
  },
  filters: {
    typeFilter: function typeFilter(value) {
      if (value == '1') {
        return '（单选）';
      } else if (value == '2') {
        return '';
      } else if (value == '3') {
        return '';
      }
    }
  },
  methods: {
    getQuestionnaireTypeID: function getQuestionnaireTypeID() {
      var _this2 = this;

      var params = {
        typename: "个性化套餐问卷"
      };

      _getQuestionnaireTypeID(params).then(function (res) {
        if (res.code == 200) {
          _this2.typeid = res.data;
          console.log("this.typeid", _this2.typeid);
        }
      });
    },
    //查询预约排班
    getCount: function getCount() {
      var _this3 = this;

      var _this = this;

      var params = {
        companyid: "0000",
        comapnytimes: "1",
        checkline: "1",
        institutionid: window.g.VUE_APP_INSTITUTIONID
      };
      getOrderCount(params).then(function (res) {
        if (res.code == 200) {
          _this3.orderCount = res.data;

          _this3.orderCount.forEach(function (item) {
            _this3.orderArr.push(item.bookeddate + '');
          });

          _this3.maxDate = _this3.getNextMonth();
          setTimeout(function () {
            _this.orderWeektime = _this.getWeekTime();
          }, 30);
        }
      });
    },
    //查询预约时间段
    getSetBookedTime: function getSetBookedTime(bookedDate) {
      var _this4 = this;

      bookedDate = bookedDate.replace(RegExp("-", "g"), "");
      var params = {
        bookedDate: bookedDate,
        checkLine: "1",
        institutionId: window.g.VUE_APP_INSTITUTIONID
      };

      _getSetBookedTime(params).then(function (res) {
        if (res.code == 200) {
          _this4.setBookedTime = res.data;
        }
      });
    },
    getList: function getList() {
      var _this5 = this;

      this.user = JSON.parse(localStorage.getItem("loginuser"));

      if (this.user.sexid == undefined) {
        Dialog.alert({
          title: '提示',
          message: '请您完善个人资料！'
        }).then(function () {
          _this5.$router.push({
            name: 'userinfo'
          });
        });
        return;
      }

      var age = GetAge(decrypt(this.user.cardid));

      if (age != undefined && parseInt(age) <= 18) {
        Dialog.alert({
          title: '提示',
          message: '非常抱谦，该问卷只适用于年满18以上人群，请在首页选择儿童体检套餐或咨询工作人员！！'
        }).then(function () {
          _this5.$router.push({
            name: 'home'
          });
        });
        return;
      }

      var params = {
        typename: '个性化套餐问卷'
      };
      console.log("sexid", this.user.sexid);
      selectQuestionsAndOptions(params).then(function (res) {
        if (res.code == 200) {
          if (_this5.user.sexid == '1') {
            _this5.questionList = res.data.filter(function (item) {
              return item.gender != '2';
            });
          } else if (_this5.user.sexid == '2') {
            _this5.questionList = res.data.filter(function (item) {
              return item.gender != '1';
            });
          }

          _this5.currentIndex = 0;
          _this5.currentQuestion = _this5.questionList.find(function (item, index) {
            return index == _this5.currentIndex;
          });
        }
      });
    },
    //下一题
    toNext: function toNext(item, index) {
      var _this6 = this;

      console.log(item);

      if (item != undefined) {
        if (item.title == '男' && this.user.sexid == '2') {
          Toast.fail('您选择的性别和注册资料的性别不符！');
          return;
        }

        if (item.title == '女' && this.user.sexid == '1') {
          Toast.fail('您选择的性别和注册资料的性别不符！');
          return;
        }
      } //检查是否有选择答案
      // console.log(this.result)
      // console.log(this.allAnswer)


      if (this.result.length == 0) {
        Toast.fail('您还没有选择答案');
        return;
      }

      if (this.nextText == '提 交') {
        Dialog.confirm({
          title: '提示',
          message: '所有题目已经答完，确认提交吗？'
        }).then(function () {
          //1、客户预约表 BookedPatient 插入数据
          _this6.insertBookedPatient(); //2、插入问卷表 Questionnaire，问卷答案表
          //3、点击确认预约，将问卷状态改为：已登记

        });
      }

      this.allAnswer.set(this.currentIndex, this.result);

      if (this.currentQuestion.optiontype == '2') {
        this.getExcludeQuestions(this.result.join(','));
      } else {
        this.getExcludeQuestions(this.result);
      }

      console.log(this.result);
      console.log(this.questionList); //到最后一题

      if (this.currentIndex + 1 == this.questionList.length - 1) {
        this.nextText = '提 交';
      }

      if (this.currentIndex + 1 < this.questionList.length) {
        this.prevText = '上一题'; //下一题

        this.currentIndex++;
        this.currentQuestion = this.questionList.find(function (item, index) {
          return index == _this6.currentIndex;
        });
        this.getCurrentProcess(); //下一题，如果有选择了的，则赋值选择了的答案
        //如果没有选择的，则清空

        this.result = [];
        this.allAnswer.forEach(function (value, key) {
          if (_this6.currentIndex == key) {
            _this6.result = value;
          }
        });
        this.fadeEnter = 'fade-enter';
        this.fadeLeaveActive = 'fade-leave-active';
      }
    },
    getExcludeQuestions: function getExcludeQuestions(optionId) {
      var _this7 = this;

      var param = {
        optionId: optionId
      };

      _getExcludeQuestions(param).then(function (res) {
        if (res.code == 200) {
          if (res.data == null) {
            Toast.fail(res.msg);
          } else {
            var questions = [];

            _this7.questionList.forEach(function (item, i) {
              var b = true;
              res.data.forEach(function (jtem, i) {
                if (jtem.childquestion == item.questionid) {
                  b = false;
                }
              });

              if (b) {
                questions.push(item);
              }
            });

            _this7.questionList = questions;
          }
        }
      });
    },
    //上一题
    toPrev: function toPrev() {
      var _this8 = this;

      if (this.prevText == '返回首页') {
        Dialog.confirm({
          title: '提示',
          message: '您的问卷结果会被清除，确定要返回吗？'
        }).then(function () {
          var param = {
            bookedNo: _this8.bookedNo
          };
          delBookedPatientAndQuestionnaire(param).then(function (res) {
            if (res.code == 200) {
              Toast(res.msg);
            }
          });

          _this8.$router.push({
            name: 'home'
          });
        });
      } else {
        //删除当前题目的答案
        this.allAnswer.delete(this.currentIndex); //上一题，给前面题目赋答案

        this.result = [];
        this.allAnswer.forEach(function (value, key) {
          if (_this8.currentIndex - 1 == key) {
            _this8.result = value;
          }
        });
      }

      if (this.currentIndex != 0) {
        if (this.currentIndex == 1) {
          this.prevText = '返回首页';
        } else {
          this.prevText = '上一题';
          this.nextText = '下一题';
        }

        this.currentIndex--;
        this.currentQuestion = this.questionList.find(function (item, index) {
          return index == _this8.currentIndex;
        });
        this.getCurrentProcess();
        this.fadeEnter = 'fade-enter2';
        this.fadeLeaveActive = 'fade-leave-active2';
      }
    },
    toggle: function toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    getCurrentProcess: function getCurrentProcess() {
      this.currentProgress = parseInt(this.currentIndex) / parseInt(this.questionList.length) * 100;
      this.currentPersent = this.currentProgress.toFixed(0) + '%';
    },
    submit: function submit() {
      var _this9 = this;

      if (!this.checkDate) {
        Toast.fail('请选择体检时间');
        return;
      } //添加订单


      var param = {
        companyid: "0000",
        companytimes: 1,
        enterqueue: "1",
        institutionid: window.g.VUE_APP_INSTITUTIONID,
        bookedno: this.bookedNo,
        itemmode: '2',
        packageid: this.currentPackage.packageID,
        packagename: this.currentName,
        packageamount: this.currentPackage.total,
        checkdate: this.checkDate,
        patientid: this.user.patientid,
        amt: encrypt(this.currentPackage.total),
        amount: this.currentPackage.total,
        hospitaladdress: this.hospitalAddress,
        groupIdList: this.currentPackage.selfPackageDetailList.map(function (item) {
          return item.groupID;
        })
      };
      addOrder(param).then(function (res) {
        if (res.code == 200) {
          if (res.data == '0') {
            Toast.fail(res.msg);
          } else {
            _this9.showSuccess = true;
          }
        }
      });
    },
    toOrders: function toOrders() {
      this.$router.push({
        name: 'orders'
      });
    },
    formatDate: function formatDate(date) {
      console.log(date);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    selectDate: function selectDate(date) {
      var newDate = new Date();
      this.showDate = false;

      if (this.formatDate(date) == this.formatDate(new Date())) {
        return;
      }

      this.checkDate = this.formatDate(date);
      this.getSetBookedTime(this.checkDate);
    },
    formatter: function formatter(day) {
      var _this10 = this;

      var year = day.date.getFullYear();
      var month = day.date.getMonth() + 1;
      var date = day.date.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (date < 10) {
        date = '0' + date;
      }

      var days = year + '-' + month + '-' + date;
      this.orderCount.forEach(function (item) {
        if (item.bookeddate == days) {
          if (item.status == '0') {
            day.bottomInfo = '休息';
            day.type = "disabled";
          } else if (item.status == '1') {
            var personCount = 0;

            if (parseInt(item.mennumber) > 0 || parseInt(item.womenmumber) > 0) {
              if (_this10.user.sexid == "1") {
                personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
              }

              if (_this10.user.sexid == "2") {
                personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
              }
            } else {
              personCount = parseInt(item.bookednumber) - parseInt(item.already);
            }

            if (personCount <= 0) {
              day.bottomInfo = '余 0';
              day.type = "disabled";
            } else {
              if (days <= _this10.getNow()) {
                day.type = "disabled";
              }

              day.bottomInfo = '余 ' + personCount;
            }
          }
        }
      }); //将所有的没有排期的设置为休息日

      if (!this.orderArr.includes(days)) {
        var nextMonthStr = "";
        var nextMonth = this.getNextMonth();
        var nextM = nextMonth.getMonth() + 1;
        var nextD = nextMonth.getDate();

        if (nextM < 10) {
          nextM = '0' + nextM;
        }

        if (nextD < 10) {
          nextD = '0' + nextD;
        }

        nextMonthStr = nextMonth.getFullYear() + '-' + nextM + '-' + nextD; //已经过去的时间不显示文字

        if (days >= this.getNow() && days <= nextMonthStr) {
          day.bottomInfo = '休息';
          day.type = "disabled";
        }
      }

      return day;
    },
    getNow: function getNow() {
      var d = new Date();
      var yy1 = d.getFullYear();
      var mm1 = d.getMonth() + 1;

      if (mm1 < 10) {
        mm1 = '0' + mm1;
      }

      var dd1 = d.getDate();

      if (dd1 < 10) {
        dd1 = '0' + dd1;
      }

      return yy1 + '-' + mm1 + '-' + dd1;
    },
    insertBookedPatient: function insertBookedPatient() {
      var _this11 = this;

      var param = {
        patientid: this.user.patientid,
        itemmode: "2",
        name: this.user.name,
        sexid: this.user.sexid,
        cardid: this.user.cardid,
        marital: this.user.marital,
        phone: this.user.phone,
        birthdate: this.user.birthdate.substring(0, 10),
        institutionid: window.g.VUE_APP_INSTITUTIONID
      };
      addBookedPatient(param).then(function (res) {
        if (res.code == 200) {
          _this11.bookedNo = res.data;

          _this11.insertQuestionnaire(res.data);
        }
      });
    },
    insertQuestionnaire: function insertQuestionnaire(bookedNo) {
      var _this12 = this;

      if (this.allAnswer.size == this.questionList.length) {
        var questionnaireAnswerList = new Array();
        this.questionList.forEach(function (item, i) {
          _this12.allAnswer.forEach(function (jtem, j) {
            if (i == j) {
              if (jtem instanceof Array) {
                jtem.forEach(function (ktm) {
                  var questionnaireAnswer = {
                    questionid: item.questionid,
                    result: ktm
                  };
                  questionnaireAnswerList.push(questionnaireAnswer);
                });
              } else {
                var questionnaireAnswer = {
                  questionid: item.questionid,
                  result: jtem
                };
                questionnaireAnswerList.push(questionnaireAnswer);
              }
            }
          });
        });
        var param = {
          companyid: "0000",
          comapnytimes: "1",
          checkline: "1",
          institutionid: window.g.VUE_APP_INSTITUTIONID,
          questionnaireAnswerList: questionnaireAnswerList,
          patientID: this.user.patientid,
          bookedNo: bookedNo,
          name: this.user.name,
          sexID: this.user.sexid,
          birthDate: this.user.birthdate.substring(0, 10),
          marital: this.user.marital,
          phone: this.user.phone,
          typeID: this.typeid
        };
        addQuestionnaire(param).then(function (res) {
          if (res.code == 200) {
            _this12.show = true; //获取推荐的套餐ID

            _this12.basePackage = res.data[0];
            _this12.vipPackage = res.data[1];

            if (_this12.basePackage.total > _this12.vipPackage) {
              _this12.basePackage = res.data[1];
              _this12.vipPackage = res.data[0];
            }

            _this12.deepPackage = res.data[2];
          }
        });
      }
    },
    showPackageInfo: function showPackageInfo(name, type) {
      if (type == 'base') {
        this.currentPackage = this.basePackage;
      } else if (type == 'vip') {
        this.currentPackage = this.vipPackage;
      } else if (type == 'deep') {
        this.currentPackage = this.deepPackage;
      }

      this.currentName = name;
      this.showPackage = true;
    },
    whycheck: function whycheck(str) {
      Dialog.alert({
        title: '提示',
        message: str
      }).then(function () {// on close
      });
    },
    getNextMonth: function getNextMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() + 1); //月份只显示当前月，如果要显示下一月+1

      d.setDate(d.getDate() - 1);
      var yy1 = d.getFullYear();
      var mm1 = d.getMonth();
      var dd1 = d.getDate();
      return new Date(yy1, mm1, dd1);
    },
    getWeekTime: function getWeekTime(dateParam) {
      var _this13 = this;

      // var new_Date = new Date(2021,11,10) //获取指定日期当周的一周日期
      var new_Date = new Date(); //获取本周一周日期

      if (this.orderArr.length > 0) {
        new_Date = new Date(this.orderArr[0]);
      }

      if (dateParam != undefined) {
        new_Date = new Date(dateParam);
      }

      var timesStamp = new_Date.getTime();
      var currenDay = new_Date.getDay();
      var dates = [];

      var _loop = function _loop() {
        das = new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)); // var dasStr = das.toLocaleDateString();

        var year = das.getFullYear();
        var month = das.getMonth() + 1;
        var date = das.getDate();

        if (month < 10) {
          month = '0' + month;
        }

        if (date < 10) {
          date = '0' + date;
        }

        var days = year + '-' + month + '-' + date;
        weekObj = {};
        weekObj.index = i;
        weekObj.date = days; // das.replace(/[年月]/g, '.').replace(/[日上下午]/g, '');

        weekObj.day = das.getMonth() + 1 + '/' + das.getDate();
        weekObj.week = _this13.getWeekName(das.getDay());
        weekObj.type = true;
        weekObj.number = '不可约';

        if (das.getDay() == 6 || das.getDay() == 0) {
          weekObj.type = true;
          weekObj.number = '休息';
        }

        if (_this13.orderArr.length > 0) {
          _this13.orderCount.forEach(function (item) {
            if (item.BookedDate == days) {
              if (item.Status == '0') {
                weekObj.number = '不可约';
                weekObj.type = true;
              } else if (item.Status == '1') {
                var personCount = 0;

                if (parseInt(item.MenNumber) > 0 || parseInt(item.WomenNumber) > 0) {
                  if (_this13.userInfo.sexid == "1") {
                    personCount = parseInt(item.MenNumber) - parseInt(item.Y_BookedNumber_MenNumber);
                  }

                  if (_this13.userInfo.sexid == "2") {
                    personCount = parseInt(item.WomenNumber) - parseInt(item.Y_BookedNumber_WomenNumber);
                  }
                } else {
                  personCount = parseInt(item.BookedNumber) - parseInt(item.Y_BookedNumber);
                }

                if (personCount <= 0) {
                  weekObj.number = '余 0';
                  weekObj.type = true;
                } else {
                  if (days == getNow()) {
                    _this13.checkDate = getNow();
                  }

                  weekObj.type = false;
                  weekObj.number = '余 ' + personCount;
                }
              }
            }
          });
        }

        dates.push(weekObj);
      };

      for (var i = 0; i < 7; i++) {
        var das;
        var weekObj;

        _loop();
      }

      return dates;
    },
    getWeekName: function getWeekName(day) {
      switch (day) {
        case 1:
          {
            return "周一";
            break;
          }

        case 2:
          {
            return "周二";
            break;
          }

        case 3:
          {
            return "周三";
            break;
          }

        case 4:
          {
            return "周四";
            break;
          }

        case 5:
          {
            return "周五";
            break;
          }

        case 6:
          {
            return "周六";
            break;
          }

        case 0:
          {
            return "周日";
            break;
          }

        default:
          {
            return "";
          }
      }
    }
  }
};